import '../Styles/EtatBadge.css';

interface EtatBadgeProps {
  color: string;
  label: string;
}

const EtatBadge = ({color, label}: EtatBadgeProps): JSX.Element => {
  return (
    <button className="etat-badge" style={{backgroundColor: color}} disabled>
      {label}
    </button>
  );
};

export default EtatBadge;
